<div class="card">
  <div class="card__header">
    <div class="card__heading">
      <div class="card__title-group">
        <h3 class="card__title" [class.card__title--lg]="titleSize() === 'lg'">{{ title() }}</h3>
        <ng-content select="[cardTitleBadge]" />
      </div>
      @if (subtitle() && !loading()) {
        <p class="card__subtitle" [title]="subtitle()">{{ subtitle() }}</p>
      }
    </div>
    <div class="card__actions">
      @if (!loading() && actionLabel()) {
        <xemex-text-button
          (click)="action.emit()"
          [icon]="actionIcon()"
          [iconPosition]="actionIconPosition()"
        >
          {{ actionLabel() }}
        </xemex-text-button>
      }
      <!-- Not hidden while loading, unlike the action button above: a projected control may need to
           stay reachable before the data arrives. Gate it in the consumer if it should not. -->
      <ng-content select="[cardHeaderActions]" />
    </div>
  </div>
  <div class="card__body">
    @if (loading()) {
      <div class="flex flex-col gap-3">
        <xemex-skeleton-block height="32px" />
        <xemex-skeleton-block height="32px" />
        <xemex-skeleton-block height="32px" />
      </div>
    } @else {
      <ng-content />
    }
  </div>
</div>
